import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../styles/_formSender.scss";

interface Props {}

const FormSenderGR: React.FC<Props> = (props) => {
  const [formData, setFormData] = useState<any>({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const [nameError, setNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [messageError, setMessageError] = useState(false);

  const notifySent = () => {
    toast.success("Το email σας έχει σταλεί με επιτυχία", { autoClose: 3000 });
  };
  const notifyError = () => {
    toast.error("Το email σας δεν στάλθηκε λόγω σφάλματος", {
      autoClose: 3000,
    });
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    let error = false;
    if (!formData.name) {
      setNameError(true);
      error = true;
    }
    if (!formData.email) {
      setEmailError(true);
      error = true;
    }
    if (!formData.phone) {
      setPhoneError(true);
      error = true;
    }
    if (!formData.message) {
      setMessageError(true);
      error = true;
    }

    var form_data = new FormData();
    for (var key in formData) {
      form_data.append(key, formData[key]);
    }

    if (!error) {
      try {
        const res = await fetch("https://almare-hotel.com/sendmail.php", {
          method: "POST",
          body: form_data,
        });
        notifySent();
        setFormData({
          name: "",
          phone: "",
          email: "",
          message: "",
        });
      } catch (error) {
        notifyError();
        console.error(error);
      }
    }
  
  };

  return (
    <form onSubmit={handleSubmit}>
      <ToastContainer />
      <div className="form-group">
        <h3>Φόρμα Επικοινωνίας</h3>
        <p>Για περισσότερες πληροφορίες και κρατήσεις επικοινωνήστε:</p>
        <input
          type="text"
          name="name"
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          placeholder="Ονομα"
          value={formData.name}
          onKeyDown={() => setNameError(false)}
          className="p-2 form-control "
        />
        {nameError && (
          <small className="error-message">Το όνομα απαιτείται</small>
        )}
        <br />
        <input
          type="email"
          name="email"
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          placeholder="Τηλέφωνο"
          value={formData.email}
          onKeyDown={() => setEmailError(false)}
          className="p-2 form-control"
        />
        {emailError && (
          <small className="error-message">Απαιτείται email</small>
        )}
        <br />
        <input
          type="text"
          name="phone"
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          placeholder="Aγαπητέ"
          value={formData.phone}
          onKeyDown={() => setPhoneError(false)}
          className="p-2 form-control"
        />
        {phoneError && (
          <small className="error-message">Απαιτείται τηλέφωνο</small>
        )}
        <br />
        <textarea
          name="message"
          onChange={(e) =>
            setFormData({ ...formData, message: e.target.value })
          }
          placeholder="Μήνυμα"
          value={formData.message}
          onKeyDown={() => setMessageError(false)}
          className="p-2 form-control"
        />
        {messageError && (
          <small className="error-message">Απαιτείται μήνυμα</small>
        )}
        <br />
        <br />
        <button type="submit" className="btn btn-primary w-100">
          Στείλετε
        </button>
      </div>
    </form>
  );
};

export default FormSenderGR;
